<template>
	<div class="header-PC" :class="{ 'header-PC--en': isEN }">
		<img
			:src="COMPANY_LOGO"
			alt=""
			class="header-logo"
			:style="{
				'transform': `scale(${scale})`,
				'transform-origin': 'left'
			}"
			@click="goAiditeIndex"
		/>
		<div
			class="header-nav-wrap"
			:style="{
				'transform': `scale(${scale})`,
				'transform-origin': 'right'
			}"
		>
			<div class="header-nav-item" v-for="(item, index) in MENU()" :key="index">
				<div class="header-nav-cell">
					<div class="header-nav-cell-b" @click="goMenu(item.name)">
						<span>{{ item.label }}</span>
					</div>
				</div>
				<div class="header-nav-children" v-if="item.children">
					<div
						class="header-nav-children-cell"
						v-for="(child, _index) in item.children"
						:key="_index"
						@click="goMenu(child.name, child.id)"
					>
						<span>·{{ child.label }}</span>
					</div>
				</div>
			</div>
		</div>
		<SwitchLanguage
			:style="{
				'transform': `scale(${scale})`,
				'transform-origin': 'left'
			}"
		/>
	</div>
</template>

<script setup>
import { COMPANY_LOGO } from '@/const/host';
import { MENU } from '@/utils/const';
import { useRouter } from '@/utils/api';
import i18n, { EN } from '@/locales';
import { computed } from 'vue';
import SwitchLanguage from './switch-language.vue';

defineProps({
	scale: {
		type: Number,
		default: 1
	}
});

const isEN = computed(() => i18n.locale === EN);


const goAiditeIndex = () => {
	window.location.href = 'https://www.aidite.com';
};

const router = useRouter();
const goMenu = (name, id = null) => {
	router.push({
		name: name,
		hash: id ? `#${id}` : ''
	});
	//公司治理滚动到
	setTimeout(() => {
		let dom = document.querySelector(`#${id}`);
		if (!dom) return;
		window.scrollTo({
			top: dom.offsetTop,
			behavior: 'smooth'
		});
	}, 200);
};
</script>

<style lang="less" scoped>
.header-PC {
	.header-logo {
		position: absolute;
		top: 36px;
		left: 0;
		width: 121px;
		height: 30px;
		cursor: pointer;
	}

	.header-nav-wrap {
		position: absolute;
		right: 12%;
		height: 80px;

		.header-nav-item {
			position: relative;
			min-height: 80px;
			display: inline-block;
			vertical-align: top;
			cursor: pointer;

			& + .header-nav-item {
				margin-left: 40px;
			}
			.header-nav-cell {
				position: relative;
				height: 80px;
				display: flex;
				justify-content: center;
				align-items: flex-end;

				.header-nav-cell-b {
					padding: 16px;

					span {
						color: #fff;
						font-family: 'SourceHanSansCN-Medium';
						font-size: 0.9rem;
						font-style: normal;
						font-weight: 500;
					}
				}
			}
			&::before {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				height: 0;
				border-bottom: none;
				background: linear-gradient(0deg, rgba(255, 255, 255, 0.4) -15%, rgba(255, 255, 255, 0) 100%);
				pointer-events: none;
				transition: height 0.18s ease-in-out;
			}

			&:hover {
				&::before {
					height: 80px;
					border-bottom: 3px solid #fff;
				}
				.header-nav-children {
					max-height: 500px; // 设置一个足够大的高度
					padding: 12px 0;
					transition-delay: 0.18s;
				}
			}
		}
		.header-nav-children {
			transform: translateY(23px);
			display: flex;
			flex-direction: column;
			text-align: center;
			background: #ffffff;
			max-height: 0;
			overflow: hidden;
			transition: all 0.18s ease-in-out;

			.header-nav-children-cell {
				position: relative;
				height: 36px;
				display: flex;
				align-items: center;
				color: #4e5969;
				text-align: left;

				span {
					margin: 0 16px;
					font-family: 'SourceHanSansCN-Light';
					font-size: 0.9rem;
					font-style: normal;
					font-weight: 500;
				}
				& + .header-nav-children-cell {
					margin-top: 8px;
				}
				&::after {
					content: '';
					position: absolute;
					top: 0;
					left: 8px;
					right: 8px;
					bottom: 0;
					z-index: -1;
					background: transparent;
					transition: all 0.18s ease-in-out;
				}

				&:hover {
					color: var(--theme-color);

					&::after {
						background: #f0f6fb;
					}
				}
			}
		}
	}
}

.header-PC--en {
	.header-nav-wrap {
		.header-nav-item {
			& + .header-nav-item {
				margin-left: 20px;
			}
		}
	}
	.header-nav-children {
		position: absolute;
		left: 50%;
		width: max-content;
		min-width: 100%;
		white-space: nowrap;
		transform: translate(-50%, 23px) !important;
	}
}
</style>
